// extracted by mini-css-extract-plugin
export default {"disableLink":"jm-z"};